export default "__VITE_ASSET__eZXORFdS__"